module.exports = __webpack_public_path__ + "static/media/07_finished_wiring.167916f5.jpg";